import { get } from 'lodash-es'

import { AVAILABILITY_CONSTANTS } from '@/js/plugins/store/modules/products/constants.js'

export const isProductAvailable = availability => {
  const status = get(availability, AVAILABILITY_CONSTANTS.STATUS)
  return status && AVAILABILITY_CONSTANTS.IS_AVAILABLE_TYPES.includes(status)
  // return (
  //   AVAILABILITY_CONSTANTS.IS_AVAILABLE_TYPES.indexOf(
  //     get(availability, AVAILABILITY_CONSTANTS.STATUS),
  //   ) >= 0
  // )
}
